var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-root"},[_c('index-header'),_c('el-container',{staticClass:"inner-container"},[_c('index-aside'),_c('index-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }